
export const icon = {
    color: '{form.field.icon.color}'
};

export default {
    icon
};
